import { Button, StackletLogo } from "@stacklet/ui";
import { signOut } from "aws-amplify/auth";

// Shown when a signed-in user lacks Viewer access, so they can log out rather
// than being stranded.
export function Unauthorized() {
  const logout = async () => {
    // Reload even if signOut rejects, so the button always clears the page
    // rather than stranding the user with an unhandled rejection.
    try {
      await signOut();
    } catch {
      // Ignore; the reload clears client state regardless.
    } finally {
      window.location.reload();
    }
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center">
      <StackletLogo className="mb-xl text-brand-primary" size={160} />
      <div className="mb-xs text-display-large">Unauthorized</div>
      <div className="mb-xl text-body-large">
        Missing &quot;Viewer&quot; permissions in Stacklet
      </div>
      <Button onPress={logout} variant="primary">
        Log out
      </Button>
    </div>
  );
}
